import RoutePath from 'utils/RoutePath';

export default {
  dashboard: new RoutePath('/dashboard/'),

  user: new RoutePath('/user/account-profile/profile1/'),

  rotations: new RoutePath('/rotations/'),
  rotationsArchive: new RoutePath('/archive/rotations/'),
  rotationsSchool: new RoutePath('/school-data/rotations/'),
  rotationDetails: new RoutePath('/rotations/:uuid/'),
  rotationDetailsArchive: new RoutePath('/archive/rotations/:uuid/'),

  // database: new RoutePath('/database/'),
  preceptorsOld: new RoutePath('/database/preceptors/'),
  studentsOld: new RoutePath('/database/students/'),
  databasePreceptorViewOld: new RoutePath('/database/preceptors/:uuid/'),
  databaseStudentViewOld: new RoutePath('/database/students/:uuid/'),

  preceptors: new RoutePath('/preceptors/'),
  students: new RoutePath('/students/'),
  preceptorsArchive: new RoutePath('/archive/preceptors/'),
  studentsArchive: new RoutePath('/archive/students/'),
  studentsSchool: new RoutePath('/school-data/students/'),
  clinicCoordinators: new RoutePath('/clinic-coordinator/'),
  databaseStudentView: new RoutePath('/students/:uuid/'),
  databasePreceptorView: new RoutePath('/preceptors/:uuid/'),
  databaseStudentViewArchive: new RoutePath('/archive/students/:uuid/'),
  databasePreceptorViewArchive: new RoutePath('/archive/preceptors/:uuid/'),
  clinicCoordinatorView: new RoutePath('/clinic-coordinator/:uuid/'),

  requests: new RoutePath('/requests/'),
  request: new RoutePath('/requests/:uuid/'),

  whitelists: new RoutePath('/waitlists/'),
  whitelist: new RoutePath('/waitlist/:uuid/'),

  reminders: new RoutePath('/reminders/'),

  reports: new RoutePath('/reports/'),

  settingsGeneral: new RoutePath('/settings/general/'),

  settingsFieldsListView: new RoutePath('/settings/fields/'),

  settingsWizardListView: new RoutePath('/settings/profiles/list'),
  settingsWizardDetailView: new RoutePath('/settings/profile/:uuid/'),

  settingsTags: new RoutePath('/settings/tags/'),

  settingsStateOwnership: new RoutePath('/settings/state-ownership/'),

  settingsUsers: new RoutePath('/settings/users/'),

  analytics: new RoutePath('/analytics/'),
  analyticsRotation: new RoutePath('/analytics/rotation/'),
  analyticsPreceptor: new RoutePath('/analytics/preceptor/'),
  analyticsPipeline: new RoutePath('/analytics/pipeline/'),
  analyticsCCTime: new RoutePath('/analytics/cc-time/'),
  suggestion: new RoutePath('/suggestion/'),
  adminProfile: new RoutePath('/profile'),
  notifications: new RoutePath('/notifications/'),
  school: new RoutePath('/school/'),
  schoolDetails: new RoutePath('/school/:uuid/'),

  // School admin routes
  schoolCCSchool: new RoutePath('/schoolcc/school/'),
  schoolCCSchoolDetails: new RoutePath('/schoolcc/school/:uuid/'),
  rotationsCCSchool: new RoutePath('/schoolcc/rotations/'),
  rotationsCCSchoolDetails: new RoutePath('/schoolcc/rotations/:uuid/'),
  studentsCCSchool: new RoutePath('/schoolcc/students/'),
  studentsCCSchoolDetails: new RoutePath('/schoolcc/students/:uuid/'),
  preceptorsCCSchool: new RoutePath('/schoolcc/preceptors/'),
  preceptorsCCSchoolDetails: new RoutePath('/schoolcc/preceptors/:uuid/'),
};
